export default __webpack_public_path__ + "static/media/thanos_time.0f5a15e0.png";